export default "__VITE_ASSET__dd3de0ee__"